let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3XcC5")).then(() => parcelRequire('kXYGv'));